
export const roleTabs = {
  profesor: [
    { label: 'Library', path: 'library' },
    { label: 'My Groups', path: 'groups' },
    { label: 'Badges', path: 'teacher-badges' },
    { label: 'Leaderboard', path: 'leaderboard' },
  ],
  estudiante: [
    { label: 'My Classes', path: 'myclasses' },
    { label: 'Achievements', path: 'achievements' },
    { label: 'Leaderboard', path: 'leaderboard' },
  ],
  administrativo: [
    { label: 'Badges Management', path: 'badges' },
    { label: 'Media Management', path: 'media' },
    { label: 'Users', path: 'users' },
    { label: 'Statistics', path: 'statistics' },
  ],
};
